import React from 'react';
import {Helmet} from 'react-helmet'
import * as PropTypes from "prop-types";
import BetaTag from "../../utils/components/BetaTag";

const Page = ({name, secondaryLabel = undefined, children, displayHelmetHeader = true, beta = false, breadCrumbs = undefined, headerSubComponent = undefined}) => {

    const environment = process.env.REACT_APP_ENV !== 'prod' ? process.env.REACT_APP_ENV.toString().toUpperCase() + ' | ' : '';

    return (
        <main>
            {displayHelmetHeader && <Helmet>
                <title>{`${environment}${name} | Nucleus Dashboard`}</title>
            </Helmet>}
            {displayHelmetHeader && breadCrumbs}
            <header className="page-header">
                <div>
                        <span className={'page-header-label'} data-testid={'page-header-label'}>{name}{beta ?
                            <BetaTag/> : ""}</span>
                    {secondaryLabel && <span className={'page-header-secondary-label'}
                                             data-testid={'page-header-secondary-label'}>{secondaryLabel}</span>}
                </div>
                {headerSubComponent}
            </header>
            <section>
                {children}
            </section>
        </main>
    );
}

export default Page;

Page.propTypes = {
    beta: PropTypes.bool,
    displayHelmetHeader: PropTypes.bool,
    name: PropTypes.any,
    secondaryLabel: PropTypes.string,
    children: PropTypes.any,
    breadCrumbs: PropTypes.object,
    headerSubComponent: PropTypes.any
};